import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=aa0b444a&"
import script from "./DocumentIcon.vue?vue&type=script&lang=js&"
export * from "./DocumentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports